Date.prototype.addDays = function(days) {
  const date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

Date.prototype.getNextMonday = function() {
  const d = new Date(this.valueOf());
  d.setDate(d.getDate() + (1 + 7 - d.getDay()) % 7);
  return d;
}
      $(document).ready(function() {
        $(document).on('click', ".panel__scroller.v-stack.gap-8 li button[aria-expanded='false']", function(){
            $('.panel-list__wrapper.side_nav_panel.here').addClass("hides");
            // $(this).parents('.panel-list__wrapper.side_nav_panel.here').addClass('hide');
        });

            $(document).on('click', ".jtpl-nav-close" , function(e) {
                       setTimeout(function () {
                          e.preventDefault();
                      $('.panel-list__wrapper.side_nav_panel.here').removeClass('hides');
                         }, 1000);
                        $(this).parent().parent().parent().parent().show();
                       
                      });

        
      });
//  <!-- .....droplogicx nkd 25 april.......... -->

//  <!-- .....droplogicx nkd 25 april.......... -->